import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { Toggle } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import { DurationInputField } from '../../../components/Duration/DurationInputField.js';
import '../../../components/FormGroup/FormGroup.js';
import '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import { convertDurationFormat } from '../../../utils/duration.js';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';
import { FieldItem } from '../../../components/FieldItem.js';
import { ImageField } from '../../../components/Input/ImageField/ImageField.js';
import { LottieUploadField } from './LottieUploadField.js';

var _excluded = ["duration"];
function LottieInspector(_ref) {
  var inspectorValue = _ref.value,
    onChange = _ref.onChange;
  var convertedDuration = convertDurationFormat(inspectorValue.props.duration);
  var formValue = _objectSpread2(_objectSpread2({}, inspectorValue), {}, {
    props: _objectSpread2(_objectSpread2({}, inspectorValue.props), {}, {
      duration: convertedDuration
    })
  });
  var handleToogleDuration = function handleToogleDuration(value) {
    var _inspectorValue$props = inspectorValue.props;
      _inspectorValue$props.duration;
      var rest = _objectWithoutProperties(_inspectorValue$props, _excluded);
    onChange(_objectSpread2(_objectSpread2({}, inspectorValue), {}, {
      props: _objectSpread2(_objectSpread2({}, rest), value && {
        duration: {}
      })
    }));
  };
  var duration = inspectorValue.props.duration;
  return jsx(InspectorFormProvider, {
    value: formValue,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uC378\uB124\uC77C",
    required: true,
    direction: "VERTICAL"
  }, jsx(FieldItem, {
    error: true,
    hint: "* \uC378\uB124\uC77C\uC740 Lottie\uD30C\uC77C\uACFC \uD06C\uAE30\uAC00 \uB3D9\uC77C\uD574\uC57C\uD569\uB2C8\uB2E4."
  }, jsx(ImageField, {
    name: "thumbnail"
  }))), jsx(FormContent, {
    header: "\uC774\uBBF8\uC9C0",
    required: true,
    direction: "VERTICAL"
  }, jsx(LottieUploadField, {
    name: "src"
  })), jsx(FormContent, {
    header: "\uB178\uCD9C\uC2DC\uAC04 \uC124\uC815"
  }, jsx(Toggle, {
    checked: !!duration,
    onCheck: handleToogleDuration
  })), duration && jsx(FormContent, null, jsx(DurationInputField, {
    name: "duration"
  })));
}

export { LottieInspector };
//# sourceMappingURL=LottieInspector.js.map
